export const ROOT_API = '/rse/api';

export const ENDPOINT_SEARCH = '/recherche';
export const ENDPOINT_SEARCH_UTILISATEURS = '/recherche-utilisateurs';
export const ENDPOINT_INIT = '/init';
export const ENDPOINT_VALIDATE = '/valider';
export const ENDPOINT_REJECT = '/rejeter'
export const ENDPOINT_EXPORT = '/export';
export const ENDPOINT_EXPORT_PERIODIQUE = '/export-periodique';
export const ENDPOINT_EXPORT_HEURE = "/export-heure";
export const ENDPOINT_LOGS = '/logs';
export const ENDPOINT_IMPORT = '/import';
export const ENDPOINT_MOIS_PRECEDENTS = '/mois-precedents';
export const ENDPOINT_MOIS_MANQUANTS = '/mois-manquants';
export const ENDPOINT_BROUILLON = '/brouillon';
export const ENDPOINT_SEARCH_LATEST_MARCHE = '/recherche-dernier-marche';

export const ENDPOINT_AUTH = ROOT_API + '/auth';
export const ENDPOINT_AUTH_METHOD = ENDPOINT_AUTH + '/method';
export const ENDPOINT_AUTH_LOGIN = ENDPOINT_AUTH + '/login';
export const ENDPOINT_AUTH_LOGIN_SAML = 'saml/login';
export const ENDPOINT_AUTH_LOGOUT_SAML = 'logout';
export const ENDPOINT_AUTH_LOGOUT = ENDPOINT_AUTH + '/logout';
export const ENDPOINT_AUTH_INFOS = ENDPOINT_AUTH + '/infos';

export const ENDPOINT_UTILISATEURS = ROOT_API + '/utilisateurs';
export const ENDPOINT_ADMINISTRATION = ROOT_API + '/administration';

export const ENDPOINT_ENTREPRISES = ROOT_API + '/entreprises';
export const ENDPOINT_ENTREPRISES_SIREN_EXISTE = ENDPOINT_ENTREPRISES + '/siren-existe';
export const ENDPOINT_MARCHES = ROOT_API + '/marches';
export const ENDPOINT_ENTREPRISE_MARCHE_INFOS = ROOT_API + '/entreprise-marche-infos';
export const ENDPOINT_EMPREINTE_ECONOMIQUE = ROOT_API + '/empreinte-economique';
export const ENDPOINT_EMPREINTE_ECONOMIQUE_PIECE_JUSTIFICATIF=  ENDPOINT_EMPREINTE_ECONOMIQUE  + '/piece-justificatif';
export const ENDPOINT_EMPREINTE_ECONOMIQUE_TASKS = ENDPOINT_EMPREINTE_ECONOMIQUE + ENDPOINT_IMPORT + "/tasks"

export const ENDPOINT_EMPREINTE_ECONOMIQUE_REJECT = ENDPOINT_EMPREINTE_ECONOMIQUE + ENDPOINT_REJECT;
export const ENDPOINT_EMPREINTE_ECONOMIQUE_VALIDATE = ENDPOINT_EMPREINTE_ECONOMIQUE + ENDPOINT_VALIDATE;
export const ENDPOINT_MARCHE_EFFECTIF_INFOS = ROOT_API + '/marche-effectif-infos';
export const ENDPOINT_MARCHE_EFFECTIF_INFOS_VALIDATE = ENDPOINT_MARCHE_EFFECTIF_INFOS + ENDPOINT_VALIDATE;
export const ENDPOINT_MARCHE_EFFECTIF_PIECE_JUSTIFICATIF =  ENDPOINT_MARCHE_EFFECTIF_INFOS  + '/piece-justificative';

export const ENDPOINT_MARCHE_EFFECTIF_INFOS_REJECT = ENDPOINT_MARCHE_EFFECTIF_INFOS + ENDPOINT_REJECT;
export const ENDPOINT_MARCHE_SECURITE_CHANTIERS = ROOT_API + '/marche-securite-chantiers';
export const ENDPOINT_MARCHE_SECURITE_CHANTIERS_VALIDATE = ENDPOINT_MARCHE_SECURITE_CHANTIERS + ENDPOINT_VALIDATE;
export const ENDPOINT_MARCHE_SECURITE_CHANTIERS_REJECT = ENDPOINT_MARCHE_SECURITE_CHANTIERS + ENDPOINT_REJECT;
export const ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL = ROOT_API + '/gpec-synthese-previsionnel';
export const ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL_VALIDATE = ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + ENDPOINT_VALIDATE;
export const ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL_REJECT = ENDPOINT_GPEC_SYNTHESE_PREVISIONNEL + ENDPOINT_REJECT;
export const ENDPOINT_GPEC_SYNTHESE_REALISE = ROOT_API + '/gpec-synthese-realise';
export const ENDPOINT_GPEC_SYNTHESE_REALISE_VALIDATE = ENDPOINT_GPEC_SYNTHESE_REALISE + ENDPOINT_VALIDATE;
export const ENDPOINT_GPEC_SYNTHESE_REALISE_REJECT = ENDPOINT_GPEC_SYNTHESE_REALISE + ENDPOINT_REJECT;

export const ENDPOINT_INSEE = ROOT_API + '/insee';
export const ENDPOINT_INSEE_COMMUNES = '/communes';
export const ENDPOINT_INSEE_DEPARTEMENTS = '/departements';
export const ENDPOINT_INSEE_REGIONS = '/regions';
export const ENDPOINT_INSEE_PAYS = '/pays';

export const ENDPOINT_LIGNES = ROOT_API + '/lignes';
export const ENDPOINT_TYPES_MARCHE = ROOT_API + '/types-marche';
export const ENDPOINT_CATEGORIES_SECTEUR = ROOT_API + '/categories-secteur';
export const ENDPOINT_TYPES_FORMATION = ROOT_API + '/types-formation';
export const ENDPOINT_TERRITOIRES = ROOT_API + '/territoires';
export const ENDPOINT_TRIMESTRES = ROOT_API + '/trimestres';
export const ENDPOINT_CODES_ROME = ROOT_API + '/codes-rome';
export const ENDPOINT_REFERENCES_FORMATIONS = ROOT_API + '/references-formations';
export const ENDPOINT_REPORTING = ROOT_API + '/reportings';
export const ENDPOINT_DIRECTIONS_PRESCRIPTRICES_PRINCIPALES = ROOT_API + '/directions-prescriptrices-principales';
export const ENDPOINT_REPORTING_MENSUELS = '/mensuels';
export const ENDPOINT_REPORTING_TRIMESTRIELS = '/trimestriels';
export const ENDPOINT_REPORTING_DISPENSES = '/dispenses';
export const ENDPOINT_REPORTING_DISPENSES_UTILISATEUR = '/dispenses-utilisateur';
export const ENDPOINT_CURRENT_TRIMESTRE = '/current-trimestre';
export const ENDPOINT_CURRENT_MONTH = '/current-month';








